import React from 'react';
import PropTypes from 'prop-types';

import DepartmentInformationPage from 'components/DepartmentInformationPage';
import PaginatorBlock from 'components/PaginatorBlock';

import { track } from 'tracking';

class DepartmentInformationListBlock extends React.Component {
    static propTypes = {
        departments: PropTypes.array.isRequired,
        blocksPerPage: PropTypes.number.isRequired,
        pagerLabels: PropTypes.shape({
            prevButton: PropTypes.string,
            nextButton: PropTypes.string,
        })
    }

    state = {
        currentPage: 1
    }

    _handlePageChange = page => this.setState({ currentPage: page }, () => {
        track('list_expansion', `DepartmentInformationListBlock - Page ${page}`);
    })

    _shouldBeVisible = index => {
        const { currentPage } = this.state;
        const { blocksPerPage } = this.props;

        const firstVisible = (currentPage - 1) * blocksPerPage;
        const lastVisible = firstVisible + (blocksPerPage-1);

        return (index >= firstVisible && index <= lastVisible);
    }

    render() {
        const {
            departments,
            blocksPerPage,
            pagerLabels
        } = this.props;

        const {
            currentPage,
        } = this.state;

        const hasDepartments = departments && departments.length > 0;
        const hasPagination = (departments && departments.length) > blocksPerPage;

        const pages = hasPagination && Math.ceil(departments.length / blocksPerPage);

        return (
            <div>
                <div>
                    {hasDepartments && departments.map((department, index) => (
                        <DepartmentInformationPage
                            key={index}
                            {...department}
                            style={{ display: this._shouldBeVisible(index) ? null : 'none' }}
                        />
                    ))}
                </div>
                {hasPagination && (
                    <PaginatorBlock
                        pages={pages}
                        currentPage={currentPage}
                        onPageChange={this._handlePageChange}
                        prevButtonLabel={pagerLabels && pagerLabels.prevButton ? pagerLabels.prevButton : null}
                        nextButtonLabel={pagerLabels && pagerLabels.nextButton ? pagerLabels.nextButton : null}
                    />
                )}
            </div>
        );
    }
}

export default DepartmentInformationListBlock;



// WEBPACK FOOTER //
// ./src/components/DepartmentInformationListBlock/DepartmentInformationListBlock.jsx